import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, formatDate } from "@/lib/api";

export default function SubscribersManager() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/subscribers").then((r) => setItems(r.data)); }, []);

  const exportCsv = async () => {
    const { data } = await api.get("/admin/subscribers/export", { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a"); a.href = url; a.download = "abonnes-chronique.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="subscribers-manager">
      <div className="flex items-start justify-between gap-4 mb-6">
        <div><h1 className="font-heading text-3xl font-black">Abonnés newsletter</h1><p className="text-zinc-500 text-sm mt-1">{items.length} abonné{items.length > 1 ? "s" : ""}</p></div>
        <button data-testid="subscribers-export-btn" onClick={exportCsv} className="inline-flex items-center gap-2 bg-[#111827] text-white px-4 py-2.5 text-xs font-bold uppercase tracking-wider hover:bg-black"><Download size={14} /> Exporter CSV</button>
      </div>
      <div className="bg-white border border-zinc-200 divide-y">
        {!items.length && <p className="text-sm text-zinc-500 p-6 text-center">Aucun abonné pour le moment.</p>}
        {items.map((s, i) => <div key={s.id} data-testid={`subscriber-row-${i}`} className="flex justify-between px-4 py-3 text-sm"><span className="font-medium">{s.email}</span><span className="text-zinc-500 text-xs">{formatDate(s.created_at)}</span></div>)}
      </div>
    </div>
  );
}
